function GiveawaysHeader() {
	return (
		<div
			className="relative min-h-[calc(100vh)] overflow-hidden"
			style={{
				backgroundImage: "url(/images/header-background.png)",
				backgroundSize: "cover",
				backgroundPosition: "center",
				backgroundRepeat: "no-repeat",
			}}
		>
			<div className="bg-opacity-70 flex h-screen flex-col items-center justify-center gap-4 px-6 text-center">
				<p className="web-heading-h1 z-3 text-center text-white max-sm:p-4">
					Promotions & Giveaways
				</p>
				<p className="web-body-b1 max-w-[60ch] text-white-80">
					Explore what’s live now, what’s coming next, and the prizes we’ve
					already sent home with our lucky legends.
				</p>
			</div>
		</div>
	);
}

export default GiveawaysHeader;
